/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as CommonTypes from './common-types'

export const OrderType = {
	Internal: 'INTERNAL',
	External: 'EXTERNAL'
} as const
export type OrderTypeType = (typeof OrderType)[keyof typeof OrderType]
export type OrderRewardTotal = {
	points: number
	amount: CommonTypes.Amount
}
export type SavedTokenPaymentMethod = {
	uuid: string
	bin: string
	lastDigits: string
	maskedPan: string
	cardType: CommonTypes.CardTypeType
	expiryMonth: number
	expiryYear: number
}
export type VerifoneEcomProviderConfig = {
	provider: 'VERIFONE_ECOM'
	methods: ('VERIFONE_ECOM_CARD' | 'VERIFONE_ECOM_APPLE_PAY' | 'VERIFONE_ECOM_GOOGLE_PAY')[]
	savedTokens: SavedTokenPaymentMethod[]
	environment: 'production' | 'sandbox'
}
export type VerifoneCheckoutProviderConfig = {
	provider: 'VERIFONE_CHECKOUT'
	methods: 'VERIFONE_CHECKOUT_CARD'[]
	environment: 'production' | 'sandbox'
}
export type AdyenEcomProviderConfig = {
	provider: 'ADYEN_ECOM'
	methods: ('ADYEN_ECOM_CARD' | 'ADYEN_TERMINAL_APPLE_PAY' | 'ADYEN_TERMINAL_GOOGLE_PAY')[]
	applePay?: {
		enabled: boolean
		merchantID?: string
		merchantName?: string
	}
	googlePay?: {
		enabled: boolean
	}
	environment: 'test' | 'live-eu' | 'live-us' | 'live-au' | 'live-apse' | 'live-in'
	clientKey: string
	countryCode?: string
}
export type CashProviderConfig = {
	provider: 'CASH'
	methods: ('CASH_INSTANT' | 'CASH_ASYNC')[]
}
export type LoyaltyPointsProviderConfig = {
	provider: 'LOYALTY_POINTS'
	customerCardUuid: string
}
export type PaymentProviderConfig =
	| VerifoneEcomProviderConfig
	| VerifoneCheckoutProviderConfig
	| AdyenEcomProviderConfig
	| CashProviderConfig
	| LoyaltyPointsProviderConfig
export type AddLineItemBody = {
	quantity?: number
	variantUuid?: string
	barcode?: string
	weight?: number
}
export const OrderStatus = {
	Draft: 'DRAFT',
	Completed: 'COMPLETED',
	Canceled: 'CANCELED'
} as const
export type OrderStatusType = (typeof OrderStatus)[keyof typeof OrderStatus]
export type QuantityInfo = {
	quantity: number
} & (
	| {
			pricingMethod: 'PER_UNIT'
	  }
	| {
			pricingMethod: 'PRICE_EMBEDDED'
			price: CommonTypes.Amount
	  }
	| {
			pricingMethod: 'PER_WEIGHT' | 'WEIGHT_EMBEDDED'
			weight: number
	  }
)
export type OrderItemFee = {
	uuid: string
	feeUuid: string
	name: string
	totals: CommonTypes.TaxAmount
	quantity: number
	unitPrice: CommonTypes.TaxAmount
}
export type OrderItemDiscount = {
	uuid: string
	name: string
	totals: CommonTypes.TaxAmount
}
export type OrderItemReward = {
	points: number
	percentage: number
	amount: CommonTypes.Amount
}
export type OrderItem = {
	uuid: string
	updatedAt: number
	lastScannedAt?: number
	productTitle: string
	variantTitle: string
	variantImageUrl?: string
	sku?: string
	variantUuid: string
	scannedBarcode?: string
	totals: CommonTypes.TaxAmount
	unitPrice?: CommonTypes.TaxAmount
	itemTotals: CommonTypes.TaxAmount
	feeTotals: CommonTypes.TaxAmount
	discountTotals: CommonTypes.TaxAmount
	quantityInfo: QuantityInfo
	itemFees: OrderItemFee[]
	itemDiscounts: OrderItemDiscount[]
	rewards: OrderItemReward[]
}
export type OrderItemGroup = {
	uuid: string
	items: OrderItem[]
	priceInfo:
		| {
				shouldOverridePrice: true
				totals: CommonTypes.TaxAmount
				itemTotals: CommonTypes.TaxAmount
				discountTotals: CommonTypes.TaxAmount
				feeTotals: CommonTypes.TaxAmount
				itemFees?: OrderItemFee[]
				name?: string
		  }
		| {
				shouldOverridePrice: false
		  }
}
export type TotalQuantityInfo = {
	quantity: number
} & (
	| {
			pricingMethod: 'PER_UNIT'
	  }
	| {
			pricingMethod: 'PRICE_EMBEDDED'
			prices: CommonTypes.Amount[]
	  }
	| {
			pricingMethod: 'PER_WEIGHT' | 'WEIGHT_EMBEDDED'
			weights: CommonTypes.Amount[]
	  }
)
export type OrderGiftCardRedemption = {
	uuid: string
	giftCardUuid: string
	name: string
	description: string
	amount: CommonTypes.Amount
}
export type OrderTransaction = {
	uuid: string
	date: number
	amount: CommonTypes.Amount
	provider: CommonTypes.PaymentProviderType
	method?: CommonTypes.PaymentMethodType
	cardType?: CommonTypes.CardTypeType
	lastDigits?: string
	maskedPan?: string
}
export type Order = {
	uuid: string
	type: OrderTypeType
	displayId?: string | null
	salesChannel: {
		uuid: string
		name: string
	}
	reward?: OrderRewardTotal | null
	completedAt?: number
	lastModifiedAt: number
	status: OrderStatusType
	paymentStatus: CommonTypes.OrderPaymentStatusType
	currencyCode: string
	fulfillmentType: CommonTypes.FulfillmentTypeType
	fulfillmentStatus: CommonTypes.FulfillmentStatusType
	itemGroups: OrderItemGroup[]
	totalQuantities: {
		variantUuid: string
		totalQuantityInfo: TotalQuantityInfo
	}[]
	totals: CommonTypes.TaxAmount
	vatTotals: {
		name: string
		amount: CommonTypes.Amount
	}[]
	totalAmountDue: CommonTypes.Amount
	totalDiscount: CommonTypes.Amount
	totalGiftCardAmount: CommonTypes.Amount
	giftCardRedemptions: OrderGiftCardRedemption[]
	transactions: OrderTransaction[]
}
export type OrderItemChange = {
	quantityChange?: number
	removeFromOrder?: boolean
}
export const SubmittedPaymentInfoType = {
	VerifoneCardData: 'VERIFONE_CARD_DATA',
	Verifone3dsDeviceId: 'VERIFONE_3DS_DEVICE_ID',
	Verifone3dsAuthenticationId: 'VERIFONE_3DS_AUTHENTICATION_ID',
	VerifoneWalletData: 'VERIFONE_WALLET_DATA'
} as const
export type SubmittedPaymentInfoTypeType = (typeof SubmittedPaymentInfoType)[keyof typeof SubmittedPaymentInfoType]
export type VerifoneEcomSubmittedPaymentInfo =
	| {
			type: 'VERIFONE_CARD_DATA'
			encryptedCardData?: string
			saveCard?: boolean
			errorCode?: string
			error?: string
	  }
	| {
			type: 'VERIFONE_3DS_DEVICE_ID'
			deviceId: string
	  }
	| {
			type: 'VERIFONE_3DS_AUTHENTICATION_ID'
			authenticationId: string
	  }
	| {
			type: 'VERIFONE_WALLET_DATA'
			walletType?: 'APPLE_PAY' | 'GOOGLE_PAY'
			walletPayload: any
			errorCode?: string
			error?: string
	  }
export type OrderInitiatedPaymentInfoBody = {
	clientReference: string
} & (
	| {
			provider:
				| 'VIPPS_MOBILEPAY'
				| 'NETS_TERMINAL'
				| 'ADYEN_TERMINAL'
				| 'RAPYD_CLOUDLINK'
				| 'TEYA_POSLINK'
				| 'VERIFONE_POS_CLOUD'
	  }
	| {
			provider: 'CASH'
			method: 'CASH_INSTANT' | 'CASH_ASYNC'
	  }
	| {
			provider: 'BLIKK_POS'
			qrCode: string
	  }
	| {
			provider: 'ADYEN_ECOM'
			returnUrl: string
			shopperReference?: string
			channel?: 'IOS' | 'ANDROID' | 'WEB'
	  }
	| {
			provider: 'VERIFONE_CHECKOUT'
			method:
				| {
						type: 'VERIFONE_CHECKOUT_CARD'
				  }
				| {
						type: 'VERIFONE_CHECKOUT_TOKEN'
						tokenUuid: string
				  }
	  }
	| {
			provider: 'VERIFONE_ECOM'
			method:
				| {
						type: 'VERIFONE_ECOM_CARD' | 'VERIFONE_ECOM_CARD_CAPTURE'
				  }
				| {
						type: 'VERIFONE_ECOM_APPLE_PAY' | 'VERIFONE_ECOM_GOOGLE_PAY'
				  }
				| {
						type: 'VERIFONE_ECOM_TOKEN'
						tokenUuid: string
				  }
	  }
	| {
			provider: 'LOYALTY_POINTS'
			customerCardUuid: string
	  }
	| {
			provider: 'BUSINESS_CARD'
			businessCardUuid?: string
			cardNumber?: string
			pin: string
	  }
)
export const TransactionStatus = {
	PendingAuth: 'PENDING_AUTH',
	PendingAuthInfoSubmitted: 'PENDING_AUTH_INFO_SUBMITTED',
	Authorized: 'AUTHORIZED',
	Reserved: 'RESERVED',
	Completed: 'COMPLETED',
	Failed: 'FAILED',
	PendingCancel: 'PENDING_CANCEL',
	Canceled: 'CANCELED',
	Expired: 'EXPIRED'
} as const
export type TransactionStatusType = (typeof TransactionStatus)[keyof typeof TransactionStatus]
export type AdyenEcomData = {
	clientKey: string
	environment: 'TEST' | 'LIVE'
	sessionId: string
	sessionData: string
	countryCode: string
}
export type VerifoneCheckoutData = {
	checkoutId: string
	checkoutUrl?: string
}
export type VerifoneEcomData =
	| {
			method: 'VERIFONE_ECOM_CARD_CAPTURE'
			checkoutId: string
			checkoutUrl?: string
	  }
	| {
			method: 'VERIFONE_ECOM_TOKEN'
	  }
	| {
			method: 'VERIFONE_ECOM_CARD'
			cardCapturePublicKey: string
			amount: CommonTypes.Amount
			currencyCode: string
	  }
	| {
			method: 'VERIFONE_ECOM_APPLE_PAY'
			merchantId: string
			merchantName: string
			amount: CommonTypes.Amount
			currencyCode: string
			countryCode: string
	  }
	| {
			method: 'VERIFONE_ECOM_GOOGLE_PAY'
			merchantId: string
			merchantName: string
			amount: CommonTypes.Amount
			currencyCode: string
			countryCode: string
			environment: 'TEST' | 'PRODUCTION'
	  }
export type PaymentInfoTransaction = {
	uuid: string
	clientReference: string
	transactionStatus: TransactionStatusType
	tokenUuid?: string
} & (
	| {
			provider:
				| 'ADYEN_TERMINAL'
				| 'BLIKK_ECOM'
				| 'BLIKK_POS'
				| 'VIPPS_MOBILEPAY'
				| 'NETS_TERMINAL'
				| 'GIFT_CARD'
				| 'BUSINESS_CARD'
				| 'STRAUMUR_ECOM'
				| 'RAPYD_CLOUDLINK'
				| 'TEYA_POSLINK'
				| 'VERIFONE_POS_CLOUD'
	  }
	| {
			provider: 'CASH'
			method: 'CASH_INSTANT' | 'CASH_ASYNC'
	  }
	| {
			provider: 'ADYEN_ECOM'
			adyenData?: AdyenEcomData
	  }
	| {
			provider: 'LOYALTY_POINTS'
			pointsUsed: number
	  }
	| {
			provider: 'VERIFONE_CHECKOUT'
			verifoneData?: VerifoneCheckoutData
	  }
	| {
			provider: 'VERIFONE_ECOM'
			method:
				| 'VERIFONE_ECOM_CARD'
				| 'VERIFONE_ECOM_TOKEN'
				| 'VERIFONE_ECOM_CARD_CAPTURE'
				| 'VERIFONE_ECOM_APPLE_PAY'
				| 'VERIFONE_ECOM_GOOGLE_PAY'
			verifoneData?: VerifoneEcomData
	  }
)
export type OrderPaymentInfoResponse = {
	status: CommonTypes.OrderPaymentStatusType
	amountStillDue: CommonTypes.Amount
	currencyCode: string
	transactions: PaymentInfoTransaction[]
}

export const zOrderType = z.enum(['INTERNAL', 'EXTERNAL'])
export const zOrderRewardTotal = z.object({
	points: z.number(),
	amount: CommonTypes.zAmount
})
export const zSavedTokenPaymentMethod = z.object({
	uuid: z.string(),
	bin: z.string(),
	lastDigits: z.string(),
	maskedPan: z.string(),
	cardType: CommonTypes.zCardType,
	expiryMonth: z.number(),
	expiryYear: z.number()
})
export const zVerifoneEcomProviderConfig = z.object({
	provider: z.enum(['VERIFONE_ECOM']),
	methods: z.array(z.enum(['VERIFONE_ECOM_CARD', 'VERIFONE_ECOM_APPLE_PAY', 'VERIFONE_ECOM_GOOGLE_PAY'])),
	savedTokens: z.array(zSavedTokenPaymentMethod),
	environment: z.enum(['production', 'sandbox'])
})
export const zVerifoneCheckoutProviderConfig = z.object({
	provider: z.enum(['VERIFONE_CHECKOUT']),
	methods: z.array(z.enum(['VERIFONE_CHECKOUT_CARD'])),
	environment: z.enum(['production', 'sandbox'])
})
export const zAdyenEcomProviderConfig = z.object({
	provider: z.enum(['ADYEN_ECOM']),
	methods: z.array(z.enum(['ADYEN_ECOM_CARD', 'ADYEN_TERMINAL_APPLE_PAY', 'ADYEN_TERMINAL_GOOGLE_PAY'])),
	applePay: z
		.object({
			enabled: z.boolean(),
			merchantID: z.string().optional(),
			merchantName: z.string().optional()
		})
		.optional(),
	googlePay: z
		.object({
			enabled: z.boolean()
		})
		.optional(),
	environment: z.enum(['test', 'live-eu', 'live-us', 'live-au', 'live-apse', 'live-in']),
	clientKey: z.string(),
	countryCode: z.string().optional()
})
export const zCashProviderConfig = z.object({
	provider: z.enum(['CASH']),
	methods: z.array(z.enum(['CASH_INSTANT', 'CASH_ASYNC']))
})
export const zLoyaltyPointsProviderConfig = z.object({
	provider: z.enum(['LOYALTY_POINTS']),
	customerCardUuid: z.string()
})
export const zPaymentProviderConfig = z.union([
	zVerifoneEcomProviderConfig,
	zVerifoneCheckoutProviderConfig,
	zAdyenEcomProviderConfig,
	zCashProviderConfig,
	zLoyaltyPointsProviderConfig
])
export const zAddLineItemBody = z.object({
	quantity: z.number().optional(),
	variantUuid: z.string().optional(),
	barcode: z.string().optional(),
	weight: z.number().optional()
})
export const zOrderStatus = z.enum(['DRAFT', 'COMPLETED', 'CANCELED'])
export const zQuantityInfo = z.intersection(
	z.object({
		quantity: z.number()
	}),
	z.union([
		z.object({
			pricingMethod: z.enum(['PER_UNIT'])
		}),
		z.object({
			pricingMethod: z.enum(['PRICE_EMBEDDED']),
			price: CommonTypes.zAmount
		}),
		z.object({
			pricingMethod: z.enum(['PER_WEIGHT', 'WEIGHT_EMBEDDED']),
			weight: z.number()
		})
	])
)
export const zOrderItemFee = z.object({
	uuid: z.string(),
	feeUuid: z.string(),
	name: z.string(),
	totals: CommonTypes.zTaxAmount,
	quantity: z.number(),
	unitPrice: CommonTypes.zTaxAmount
})
export const zOrderItemDiscount = z.object({
	uuid: z.string(),
	name: z.string(),
	totals: CommonTypes.zTaxAmount
})
export const zOrderItemReward = z.object({
	points: z.number(),
	percentage: z.number(),
	amount: CommonTypes.zAmount
})
export const zOrderItem = z.object({
	uuid: z.string(),
	updatedAt: z.number(),
	lastScannedAt: z.number().optional(),
	productTitle: z.string(),
	variantTitle: z.string(),
	variantImageUrl: z.string().optional(),
	sku: z.string().optional(),
	variantUuid: z.string(),
	scannedBarcode: z.string().optional(),
	totals: CommonTypes.zTaxAmount,
	unitPrice: CommonTypes.zTaxAmount.optional().nullable(),
	itemTotals: CommonTypes.zTaxAmount,
	feeTotals: CommonTypes.zTaxAmount,
	discountTotals: CommonTypes.zTaxAmount,
	quantityInfo: zQuantityInfo,
	itemFees: z.array(zOrderItemFee),
	itemDiscounts: z.array(zOrderItemDiscount),
	rewards: z.array(zOrderItemReward)
})
export const zOrderItemGroup = z.object({
	uuid: z.string(),
	items: z.array(zOrderItem),
	priceInfo: z.union([
		z.object({
			shouldOverridePrice: z.literal(true),
			totals: CommonTypes.zTaxAmount,
			itemTotals: CommonTypes.zTaxAmount,
			discountTotals: CommonTypes.zTaxAmount,
			feeTotals: CommonTypes.zTaxAmount,
			itemFees: z.array(zOrderItemFee).optional(),
			name: z.string().optional()
		}),
		z.object({
			shouldOverridePrice: z.literal(false)
		})
	])
})
export const zTotalQuantityInfo = z.intersection(
	z.object({
		quantity: z.number()
	}),
	z.union([
		z.object({
			pricingMethod: z.enum(['PER_UNIT'])
		}),
		z.object({
			pricingMethod: z.enum(['PRICE_EMBEDDED']),
			prices: z.array(CommonTypes.zAmount)
		}),
		z.object({
			pricingMethod: z.enum(['PER_WEIGHT', 'WEIGHT_EMBEDDED']),
			weights: z.array(CommonTypes.zAmount)
		})
	])
)
export const zOrderGiftCardRedemption = z.object({
	uuid: z.string(),
	giftCardUuid: z.string(),
	name: z.string(),
	description: z.string(),
	amount: CommonTypes.zAmount
})
export const zOrderTransaction = z.object({
	uuid: z.string(),
	date: z.number(),
	amount: CommonTypes.zAmount,
	provider: CommonTypes.zPaymentProvider,
	method: CommonTypes.zPaymentMethod.optional(),
	cardType: CommonTypes.zCardType.optional(),
	lastDigits: z.string().optional(),
	maskedPan: z.string().optional()
})
export const zOrder = z.object({
	uuid: z.string(),
	type: zOrderType,
	displayId: z.string().optional().nullable(),
	salesChannel: z.object({
		uuid: z.string(),
		name: z.string()
	}),
	reward: zOrderRewardTotal.optional().nullable(),
	completedAt: z.number().optional(),
	lastModifiedAt: z.number(),
	status: zOrderStatus,
	paymentStatus: CommonTypes.zOrderPaymentStatus,
	currencyCode: z.string(),
	fulfillmentType: CommonTypes.zFulfillmentType,
	fulfillmentStatus: CommonTypes.zFulfillmentStatus,
	itemGroups: z.array(zOrderItemGroup),
	totalQuantities: z.array(
		z.object({
			variantUuid: z.string(),
			totalQuantityInfo: zTotalQuantityInfo
		})
	),
	totals: CommonTypes.zTaxAmount,
	vatTotals: z.array(
		z.object({
			name: z.string(),
			amount: CommonTypes.zAmount
		})
	),
	totalAmountDue: CommonTypes.zAmount,
	totalDiscount: CommonTypes.zAmount,
	totalGiftCardAmount: CommonTypes.zAmount,
	giftCardRedemptions: z.array(zOrderGiftCardRedemption),
	transactions: z.array(zOrderTransaction)
})
export const zOrderItemChange = z.object({
	quantityChange: z.number().optional(),
	removeFromOrder: z.boolean().optional()
})
export const zSubmittedPaymentInfoType = z.enum([
	'VERIFONE_CARD_DATA',
	'VERIFONE_3DS_DEVICE_ID',
	'VERIFONE_3DS_AUTHENTICATION_ID',
	'VERIFONE_WALLET_DATA'
])
export const zVerifoneEcomSubmittedPaymentInfo = z.union([
	z.object({
		type: z.enum(['VERIFONE_CARD_DATA']),
		encryptedCardData: z.string().optional(),
		saveCard: z.boolean().optional(),
		errorCode: z.string().optional(),
		error: z.string().optional()
	}),
	z.object({
		type: z.enum(['VERIFONE_3DS_DEVICE_ID']),
		deviceId: z.string()
	}),
	z.object({
		type: z.enum(['VERIFONE_3DS_AUTHENTICATION_ID']),
		authenticationId: z.string()
	}),
	z.object({
		type: z.enum(['VERIFONE_WALLET_DATA']),
		walletType: z.enum(['APPLE_PAY', 'GOOGLE_PAY']).optional(),
		walletPayload: z.any(),
		errorCode: z.string().optional(),
		error: z.string().optional()
	})
])
export const zOrderInitiatedPaymentInfoBody = z.intersection(
	z.object({
		clientReference: z.string()
	}),
	z.union([
		z.object({
			provider: z.enum([
				'VIPPS_MOBILEPAY',
				'NETS_TERMINAL',
				'ADYEN_TERMINAL',
				'RAPYD_CLOUDLINK',
				'TEYA_POSLINK',
				'VERIFONE_POS_CLOUD'
			])
		}),
		z.object({
			provider: z.enum(['CASH']),
			method: z.enum(['CASH_INSTANT', 'CASH_ASYNC'])
		}),
		z.object({
			provider: z.enum(['BLIKK_POS']),
			qrCode: z.string()
		}),
		z.object({
			provider: z.enum(['ADYEN_ECOM']),
			returnUrl: z.string(),
			shopperReference: z.string().optional(),
			channel: z.enum(['IOS', 'ANDROID', 'WEB']).optional()
		}),
		z.object({
			provider: z.enum(['VERIFONE_CHECKOUT']),
			method: z.union([
				z.object({
					type: z.enum(['VERIFONE_CHECKOUT_CARD'])
				}),
				z.object({
					type: z.enum(['VERIFONE_CHECKOUT_TOKEN']),
					tokenUuid: z.string()
				})
			])
		}),
		z.object({
			provider: z.enum(['VERIFONE_ECOM']),
			method: z.union([
				z.object({
					type: z.enum(['VERIFONE_ECOM_CARD', 'VERIFONE_ECOM_CARD_CAPTURE'])
				}),
				z.object({
					type: z.enum(['VERIFONE_ECOM_APPLE_PAY', 'VERIFONE_ECOM_GOOGLE_PAY'])
				}),
				z.object({
					type: z.enum(['VERIFONE_ECOM_TOKEN']),
					tokenUuid: z.string()
				})
			])
		}),
		z.object({
			provider: z.enum(['LOYALTY_POINTS']),
			customerCardUuid: z.string()
		}),
		z.object({
			provider: z.enum(['BUSINESS_CARD']),
			businessCardUuid: z.string().optional(),
			cardNumber: z.string().optional(),
			pin: z.string()
		})
	])
)
export const zTransactionStatus = z.enum([
	'PENDING_AUTH',
	'PENDING_AUTH_INFO_SUBMITTED',
	'AUTHORIZED',
	'RESERVED',
	'COMPLETED',
	'FAILED',
	'PENDING_CANCEL',
	'CANCELED',
	'EXPIRED'
])
export const zAdyenEcomData = z.object({
	clientKey: z.string(),
	environment: z.enum(['TEST', 'LIVE']),
	sessionId: z.string(),
	sessionData: z.string(),
	countryCode: z.string()
})
export const zVerifoneCheckoutData = z.object({
	checkoutId: z.string(),
	checkoutUrl: z.string().optional()
})
export const zVerifoneEcomData = z.union([
	z.object({
		method: z.enum(['VERIFONE_ECOM_CARD_CAPTURE']),
		checkoutId: z.string(),
		checkoutUrl: z.string().optional()
	}),
	z.object({
		method: z.enum(['VERIFONE_ECOM_TOKEN'])
	}),
	z.object({
		method: z.enum(['VERIFONE_ECOM_CARD']),
		cardCapturePublicKey: z.string(),
		amount: CommonTypes.zAmount,
		currencyCode: z.string()
	}),
	z.object({
		method: z.enum(['VERIFONE_ECOM_APPLE_PAY']),
		merchantId: z.string(),
		merchantName: z.string(),
		amount: CommonTypes.zAmount,
		currencyCode: z.string(),
		countryCode: z.string()
	}),
	z.object({
		method: z.enum(['VERIFONE_ECOM_GOOGLE_PAY']),
		merchantId: z.string(),
		merchantName: z.string(),
		amount: CommonTypes.zAmount,
		currencyCode: z.string(),
		countryCode: z.string(),
		environment: z.enum(['TEST', 'PRODUCTION'])
	})
])
export const zPaymentInfoTransaction = z.intersection(
	z.object({
		uuid: z.string(),
		clientReference: z.string(),
		transactionStatus: zTransactionStatus,
		tokenUuid: z.string().optional()
	}),
	z.union([
		z.object({
			provider: z.enum([
				'ADYEN_TERMINAL',
				'BLIKK_ECOM',
				'BLIKK_POS',
				'VIPPS_MOBILEPAY',
				'NETS_TERMINAL',
				'GIFT_CARD',
				'BUSINESS_CARD',
				'STRAUMUR_ECOM',
				'RAPYD_CLOUDLINK',
				'TEYA_POSLINK',
				'VERIFONE_POS_CLOUD'
			])
		}),
		z.object({
			provider: z.enum(['CASH']),
			method: z.enum(['CASH_INSTANT', 'CASH_ASYNC'])
		}),
		z.object({
			provider: z.enum(['ADYEN_ECOM']),
			adyenData: zAdyenEcomData.optional().nullable()
		}),
		z.object({
			provider: z.enum(['LOYALTY_POINTS']),
			pointsUsed: z.number()
		}),
		z.object({
			provider: z.enum(['VERIFONE_CHECKOUT']),
			verifoneData: zVerifoneCheckoutData.optional().nullable()
		}),
		z.object({
			provider: z.enum(['VERIFONE_ECOM']),
			method: z.enum([
				'VERIFONE_ECOM_CARD',
				'VERIFONE_ECOM_TOKEN',
				'VERIFONE_ECOM_CARD_CAPTURE',
				'VERIFONE_ECOM_APPLE_PAY',
				'VERIFONE_ECOM_GOOGLE_PAY'
			]),
			verifoneData: zVerifoneEcomData.optional().nullable()
		})
	])
)
export const zOrderPaymentInfoResponse = z.object({
	status: CommonTypes.zOrderPaymentStatus,
	amountStillDue: CommonTypes.zAmount,
	currencyCode: z.string(),
	transactions: z.array(zPaymentInfoTransaction)
})
